
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 16 14","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M15.666.704c.384.32.446.904.14 1.305L7.271 13.152a.878.878 0 01-.63.346.867.867 0 01-.672-.25L.28 7.679a.958.958 0 01-.04-1.313.862.862 0 011.257-.042l4.987 4.884L14.417.85a.863.863 0 011.25-.145z","fill":"currentColor"}})])
          )
        }
      }
    